export interface ChatMemberMentionCandidate {
  id: string;
  fullName: string;
}

export interface ActiveMemberMention {
  startIndex: number;
  endIndex: number;
  query: string;
}

export const CHAT_MEMBER_MENTION_DEBOUNCE_MS = 300;
export const CHAT_MEMBER_MENTION_LIMIT = 5;

export function findActiveMemberMention(
  text: string,
  cursorIndex: number = text.length,
): ActiveMemberMention | null {
  const beforeCursor = text.slice(0, cursorIndex);
  const match = beforeCursor.match(/(?:^|\s)@([^\s@]*)$/);

  if (!match) {
    return null;
  }

  const query = match[1] ?? '';
  const atIndex = beforeCursor.lastIndexOf('@');

  if (atIndex < 0) {
    return null;
  }

  return {
    startIndex: atIndex,
    endIndex: cursorIndex,
    query,
  };
}

export function filterMembersForMention(
  members: ChatMemberMentionCandidate[],
  query: string,
  limit: number = CHAT_MEMBER_MENTION_LIMIT,
): ChatMemberMentionCandidate[] {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return [];
  }

  return [...members]
    .sort((a, b) => a.fullName.localeCompare(b.fullName, undefined, { sensitivity: 'base' }))
    .filter((member) => {
      const fullName = member.fullName.toLowerCase();
      const firstName = fullName.split(/\s+/)[0] ?? '';

      return firstName.startsWith(normalizedQuery) || fullName.startsWith(normalizedQuery);
    })
    .slice(0, limit);
}

export function applyMemberMentionSelection(
  text: string,
  mention: ActiveMemberMention,
  member: ChatMemberMentionCandidate,
): string {
  const before = text.slice(0, mention.startIndex);
  const after = text.slice(mention.endIndex);

  return `${before}@${member.fullName} ${after}`;
}

export function mentionSelectionCursorIndex(
  mention: ActiveMemberMention,
  member: ChatMemberMentionCandidate,
): number {
  return mention.startIndex + `@${member.fullName} `.length;
}
